import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import AdminDashboard from "./Components/AdminDashboard";
import WelcomeScreen from "./Components/WelcomeScreen";
import ProfilePage from "./Components/ProfilePage";
import MainApp from "./MainApp";
import { getStoredUser } from "./Components/Utils/getStoredUser";

const App = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const storedUser = getStoredUser(); // For admin login
    const uid = localStorage.getItem("uid"); // For profile access

    if (storedUser) {
      // If the user is an admin, set the user and redirect to the admin dashboard
      setUser(storedUser);
      if (location.pathname !== "/admin") {
        navigate("/admin");
      }
    } else if (location.pathname.startsWith("/")) {
      // If accessing a username-based route (e.g., /vallarasuk), do nothing to allow the route
      // Assumption: If the URL starts with "/", it's a profile route (e.g., /username)
    } else if (!uid) {
      // If no uid and not an admin, redirect to the main app
      navigate("/");
    }
  }, [user, navigate, location]);

  // Route Configuration Array
  const routes = [
    {
      path: "/",
      element: user ? <Navigate to="/admin" replace /> : <MainApp />,
      protected: false,
    },
    {
      path: "/admin/*",
      element: <AdminDashboard setUser={setUser} />,
      protected: true,
    },
    {
      path: "/:username",
      element: <ProfilePage />,
      protected: false,
    },
    {
      path: "/welcome",
      element: <WelcomeScreen />,
      protected: false,
    },
  ];

  return (
    <Routes>
      {routes.map(({ path, element, protected: isProtected }) => (
        <Route key={path} path={path} element={element} />
      ))}
    </Routes>
  );
};

export default App;
